// @flow

export default {
  gray: '#E8E8E8',
  darkGray: '#9B9B9B',
  black: '#000000',
  red: '#D01924',
  white: '#fff',
};
